import getColumnType from "../../../helpers/intakeForms/getColumnType";

// The respondent-facing matrix (table) field: one input per cell, typed by its
// column.
//
// Layout reuses the questionnaire matrix design (src/components/open/FieldType.jsx
// + src/CSS/open/questionnaire.css): a CSS grid with `display: contents` rows,
// shared `.matrix-grid-header` / `.matrix-grid-item` cells. The column count is
// dynamic, so grid-template-columns is set inline exactly as the questionnaire
// matrix does — the one value that cannot live in a static stylesheet.
//
// Rows, columns AND the answer options of every 'choice' column are prefetched
// by IntakeFormOpen. Nothing here touches Firestore: a cell that fetched its own
// options would open one listener per row for the same option set.
//
// AI-CONTEXT: See docs/features/matrix-field-intakeform.md
const IntakeFormMatrixField = ({
    field,
    rows,
    columns,
    options,
    getCellValue,
    setCellValue,
    invalid,
}) => {
    const allRows = rows || [];
    const allColumns = columns || [];

    // An unfinished matrix (no rows or no columns) has nothing to ask.
    if (allRows.length === 0 || allColumns.length === 0) return null;

    const renderCell = (row, column) => {
        const type = getColumnType(column);
        const value = getCellValue(field.ID, row.ID, column.ID);
        const onChange = (e) => setCellValue(field, row, column, e.target.value);

        if (type === "choice") {
            return (
                <select value={value} onChange={onChange}>
                    <option value="">Selecteer een optie</option>
                    {((options || {})[column.ID] || []).map((option) => (
                        <option key={option.ID} value={option.Option}>
                            {option.Option}
                        </option>
                    ))}
                </select>
            );
        }

        return (
            <input
                type={type === "number" ? "number" : "text"}
                value={value}
                onChange={onChange}
            />
        );
    };

    return (
        <div
            className={`intake-matrix-scroll${invalid ? " intake-matrix-invalid" : ""}`}
        >
            <div
                className="intake-matrix-grid"
                style={{
                    gridTemplateColumns: `minmax(160px, 1.4fr) repeat(${allColumns.length}, minmax(140px, 1fr))`,
                }}
            >
                {/* top-left corner */}
                <div className="matrix-grid-header" />

                {/* column titles */}
                {allColumns.map((column) => (
                    <div key={column.ID} className="matrix-grid-header">
                        <p>{column.Title}</p>
                    </div>
                ))}

                {/* one row = a header cell + one input cell per column */}
                {allRows.map((row) => (
                    <div key={row.ID} className="intake-matrix-row">
                        <div className="matrix-grid-header first-column">
                            <p>{row.Title}</p>
                        </div>
                        {allColumns.map((column) => (
                            <div key={column.ID} className="matrix-grid-item">
                                {renderCell(row, column)}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IntakeFormMatrixField;
